import {
  LOGIN_TYPE_ADM,
  LOGIN_TYPE_ADMLIMITED,
  OPT_TASKS_LIST_STATUS_ALL_VALUE,
  OPT_TASKS_LIST_TYPE_ALL_VALUE,
  OPT_TASKS_LIST_TYPE_EMAIL_ID,
  OPT_TASKS_LIST_TYPE_SMS_ID,
  POLLING_MAX_INTERVAL,
  POLLING_MAX_ITERATION,
  STORE_KEY_LOGIN_TYPE
} from 'Constants/'
import getIntl from 'Helpers/intl'

import { storeGet } from 'Helpers/localStorage'
import { logAppError } from 'Helpers/logger'
import { STORE_KEY_ID_LIST } from 'mailup-react-helpers'

import {
  TOAST_VARIANT_ERROR,
  TOAST_VARIANT_SUCCESS,
  toastShow
} from 'mailup-web-components'
import {
  checkCanCreate,
  copyTrigger,
  deleteTask,
  getCountOfSMSSent,
  getMessageMinimumDetails,
  getMessageTotalCounters,
  getSmsMessageGetSMSDetails,
  getTags,
  getTasksList,
  setTaskEnable,
  simulate,
  simulateAsync
} from 'Pages/TasksList/recoil/actions/actions'
import { pageState } from 'Pages/TasksList/recoil/state/page'
import { modalCopy, modalDelete, modalSimulate } from '../state/modals'
import {
  moreResults,
  paginationState,
  searchResult,
  searchState,
  tagsState
} from '../state/search'
import { pendoTrack } from 'Helpers/pendoTracking'

async function doFetch(set, init, searchParams, pageNumber, pageSize) {
  if (init) {
    set(pageState, (prev) => ({
      ...prev,
      loading: true,
      loaded: false
    }))
  } else {
    set(pageState, (prev) => ({
      ...prev,
      fetchingResults: true,
      error: false
    }))
  }

  try {
    const loginType = storeGet(STORE_KEY_LOGIN_TYPE)
    const params = {
      pageNumber,
      pageSize
    }

    const bodyParams =
      loginType === LOGIN_TYPE_ADM || loginType === LOGIN_TYPE_ADMLIMITED
        ? {
            TagIds: searchParams.tagIds,
            Hide: null
          }
        : {
            TagIds: searchParams.tagIds,
            Hide: false
          }

    if (searchParams.searchText !== '') {
      bodyParams.SearchText = searchParams.searchText
    }
    if (searchParams.isEnabled !== OPT_TASKS_LIST_STATUS_ALL_VALUE) {
      bodyParams.IsEnabled = searchParams.isEnabled
    }
    if (searchParams.action !== OPT_TASKS_LIST_TYPE_ALL_VALUE) {
      bodyParams.Action = searchParams.action
    }

    const [{ Result: canCreateTrigger }, res, tags] = await Promise.all([
      checkCanCreate(),
      getTasksList(params, bodyParams),
      getTags()
    ])

    set(pageState, (prev) => ({
      ...prev,
      canCreateTrigger
    }))
    set(searchResult, (prev) => ({
      ...prev,
      items: res.Items
    }))
    set(paginationState, (prev) => ({
      ...prev,
      totalItems: res.TotalItems
    }))
    set(tagsState, tags)
    if (init && res.TotalItems === 0) {
      set(pageState, (prev) => ({
        ...prev,
        isEmptyState: true
      }))
    }
  } catch (error) {
    logAppError({
      appError: error
    })
    set(pageState, (prev) => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }

  if (init) {
    set(pageState, (prev) => ({
      ...prev,
      loading: false,
      loaded: true
    }))
  } else {
    set(pageState, (prev) => ({
      ...prev,
      fetchingResults: false
    }))
  }
}

export const searchTasksCallback =
  ({ snapshot, set }) =>
  async (init = false) => {
    const searchParams = await snapshot.getPromise(searchState)
    const { pageNumber, pageSize } = await snapshot.getPromise(paginationState)

    await doFetch(set, init, searchParams, pageNumber, pageSize)
  }

export const pageChangeCallback =
  ({ snapshot, set }) =>
  async (pageNumber) => {
    const searchParams = await snapshot.getPromise(searchState)
    const { pageSize } = await snapshot.getPromise(paginationState)
    set(paginationState, (prev) => ({
      ...prev,
      pageNumber
    }))

    await doFetch(set, false, searchParams, pageNumber, pageSize)
  }

export const pageSizeChangeCallback =
  ({ snapshot, set }) =>
  async (pageSize) => {
    const searchParams = await snapshot.getPromise(searchState)
    set(paginationState, (prev) => ({
      ...prev,
      pageSize
    }))

    await doFetch(set, false, searchParams, 1, pageSize)
  }

export const resetSearchCallback =
  ({ reset, set, snapshot }) =>
  async () => {
    reset(searchState)
    reset(searchResult)
    reset(paginationState)
    set(pageState, (prev) => ({
      ...prev,
      loaded: false
    }))
  }

export const fetchMoreResultsCallback =
  ({ set }) =>
  async (idTask, idMessage, actionType) => {
    set(moreResults(idTask), (prev) => ({
      ...prev,
      moreLoading: true,
      moreLoaded: false
    }))

    try {
      if (actionType === OPT_TASKS_LIST_TYPE_EMAIL_ID) {
        const idList = storeGet(STORE_KEY_ID_LIST)
        const [moreMessageDetails, { Counters: moreCountMessage }] =
          await Promise.all([
            getMessageMinimumDetails(idMessage),
            getMessageTotalCounters(idList, idMessage, ['EI'])
          ])

        set(moreResults(idTask), (prev) => ({
          ...prev,
          moreMessageDetails,
          moreCountMessage: moreCountMessage.TotalCounters.EI
        }))
      }
      if (actionType === OPT_TASKS_LIST_TYPE_SMS_ID) {
        const [moreMessageDetails, { Count: moreCountMessage }] =
          await Promise.all([
            getSmsMessageGetSMSDetails(idMessage),
            getCountOfSMSSent(idMessage)
          ])

        set(moreResults(idTask), (prev) => ({
          ...prev,
          moreMessageDetails,
          moreCountMessage
        }))
      }
    } catch (error) {
      logAppError({
        Component: 'TasksList',
        Method: 'fetchMoreResultsCallback',
        appError: error
      })
      set(moreResults(idTask), {
        error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
        severity: 'danger'
      })
    }

    set(moreResults(idTask), (prev) => ({
      ...prev,
      moreLoading: false,
      moreLoaded: true
    }))
  }

export const setStatusTaskCallback =
  ({ set }) =>
  async (idTask, status, init = false) => {
    set(moreResults(idTask), (prev) => ({
      ...prev,
      statusToggle: status
    }))

    if (!init) {
      try {
        await setTaskEnable(idTask, { Enable: status })
        const toastLabelId = status
          ? 'Load.TriggersList.SuccessActivation'
          : 'Load.TriggersList.SuccessDisable'

        toastShow(
          getIntl().formatMessage({
            id: toastLabelId
          }),
          TOAST_VARIANT_SUCCESS
        )
        if (status) {
          pendoTrack('Task  Active', {})
        }
      } catch (error) {
        logAppError({
          Component: 'TasksList',
          Method: 'setStatusTask',
          appError: error
        })
        set(moreResults(idTask), {
          error: getIntl().formatMessage({
            id: 'Load.EmailSenderSelector.EmailWarningSave'
          }),
          severity: 'danger'
        })
      }
    }
  }

export const copyTriggerCallback =
  ({ set, snapshot, reset }) =>
  async (idTask) => {
    set(modalCopy, (prev) => ({
      ...prev,
      fetchData: true
    }))

    const searchParams = await snapshot.getPromise(searchState)
    const { pageNumber, pageSize } = await snapshot.getPromise(paginationState)

    try {
      const res = await copyTrigger(idTask)

      if (res.Result) {
        toastShow(
          getIntl().formatMessage({
            id: 'Load.TriggersLists.AlertSuccessCopy'
          }),
          TOAST_VARIANT_SUCCESS,
          'copyTriggerCallbackOK'
        )
        reset(modalCopy)
        await doFetch(set, false, searchParams, pageNumber, pageSize)
      } else {
        reset(modalCopy)
        toastShow(
          getIntl().formatMessage({
            id: 'Load.TriggersList.MessageErrorSave'
          }),
          TOAST_VARIANT_ERROR,
          'copyTriggerCallbackKO'
        )
        reset(modalCopy)
      }
    } catch (error) {
      logAppError({
        appError: error
      })
      set(pageState, (prev) => ({
        ...prev,
        error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
        severity: 'danger'
      }))
    }
  }

export const simulateCallback =
  ({ set }) =>
  async (idTask) => {
    try {
      const res = await simulate(idTask)

      set(modalSimulate, (prev) => ({
        ...prev,
        idSimulate: res.Result
      }))
    } catch (error) {
      logAppError({
        appError: error
      })
      set(pageState, (prev) => ({
        ...prev,
        error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
        severity: 'danger'
      }))
    }
  }

export const simulateAsyncTaskCallback =
  ({ set, snapshot }) =>
  async (idSimulate) => {
    const { currentIteration } = await snapshot.getPromise(modalSimulate)
    try {
      const res = await simulateAsync(idSimulate)

      const m = JSON.parse(res.Metadata)
      let p = 'Processed' in m ? m.Processed : undefined
      let d = 'Discarded' in m ? m.Discarded : undefined

      if (currentIteration >= POLLING_MAX_ITERATION || res.Status === 'Error') {
        toastShow(
          getIntl().formatMessage({
            id: 'Load.Alerts.TaskSimulationError'
          }),
          TOAST_VARIANT_ERROR,
          'simulateAsyncTaskCallbackKO'
        )
        p = '-'
        d = '-'
      }

      set(modalSimulate, (prev) => ({
        ...prev,
        currentIteration: prev.currentIteration + 1,
        interval: Math.min(prev.interval * 2, POLLING_MAX_INTERVAL),
        simulateStatus: res.Status,
        simulateProcessed: p,
        simulateDiscarded: d
      }))
    } catch (error) {
      logAppError({
        appError: error
      })
      set(pageState, (prev) => ({
        ...prev,
        error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
        severity: 'danger'
      }))
    }
  }

export const deleteTaskCallback =
  ({ set, snapshot, reset }) =>
  async (idTask) => {
    const searchParams = await snapshot.getPromise(searchState)
    const { pageNumber, pageSize } = await snapshot.getPromise(paginationState)

    try {
      const res = await deleteTask(idTask)

      if (res.Result) {
        reset(modalDelete)
        await doFetch(set, false, searchParams, pageNumber, pageSize)
        toastShow(
          getIntl().formatMessage({
            id: 'Load.Alerts.TaskSuccessDelete'
          }),
          TOAST_VARIANT_SUCCESS,
          'deleteCallbackOK'
        )
      }
    } catch (error) {
      logAppError({
        appError: error
      })
      set(pageState, (prev) => ({
        ...prev,
        error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
        severity: 'danger'
      }))
    }
  }
